import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const Container = styled.div<{ mb: number }>`
  ${({ mb }) => css`
    display: block;
    margin: 8px 0 ${mb}px;
  `}
`;

export const Title = styled.h1`
  ${({ theme }) => css`
    color: ${theme.content.hierarchy1};
    font-size: 24px;
    font-weight: 600;
    letter-spacing: -0.1px;
    line-height: 22px;
  `}
`;
